const dice = document.querySelector('.dice');
const rollDice = document.querySelector(".roll-dice");
const shareWrapper = document.querySelector(".nudge__share-wrapper")

const nudgeText = document.querySelector('.nudge__text');
const nudgeShare = document.querySelector('.nudge__share');

let nudgeNumber = 0;

const roll = function () {
  let number = Math.floor(Math.random() * 6 + 1);
  console.log(number);

  for (let i = 1; i <= 6; i++) {
    dice.classList.remove('show-' + i);
  }

  for (let i = 1; i <= 6; i++) {
    if (number === i) {
      dice.classList.add('show-' + i);
      return;
    }
  }
};

const random = function () {
  nudgeNumber = Math.floor(Math.random() * nudges.length);

  generateNudge();
};

let nudgeInfo = {
  "title": "",
  "url": "",
  "text": ""
}

// Generate a nudge
const generateNudge = function () {
  const nudge = nudges[nudgeNumber];

  if (nudgeNumber >= nudges.length) {
    nudgeNumber = 0;
  }

  nudgeText.textContent = nudge;
  nudgeInfo.title = "I'm sending you a nudge!";
  nudgeInfo.text = nudge + " " + window.nudgeStrings.postscript;
  nudgeInfo.url = "https://theohcollective.com/";

  console.log("nudge")
  console.log(nudge)

  console.log("nudge info")
  console.log(nudgeInfo)
  // nudgeShare.href = `instagram://sharesheet?text=${nudge}`;
};

dice.addEventListener('click', function (event) {
  roll();
  setTimeout(random, 1500);
  setTimeout(showShare, 1500);
});

rollDice.addEventListener('click', function (event) {
  roll();
  setTimeout(random, 1500);
  setTimeout(showShare, 1500);
  event.preventDefault();
});

const showShare = function () {
  copyToClipboard.textContent = window.nudgeStrings.copyToClipboard
  rollDice.classList.add("hidden")
  shareWrapper.removeAttribute("hidden")
}

nudgeShare.addEventListener("click", async (event) => {
  try {
    await navigator.share(nudgeInfo);
    console.log("Data was shared successfully");
  } catch (err) {
    console.error("Share failed:", err.message);
  }
  event.preventDefault()
});

// Copy to clipboard
const copyToClipboard = document.querySelector(".nudge__copy")

copyToClipboard.addEventListener("click", function (event) {
  navigator.clipboard.writeText(nudgeInfo.text);
  console.log("Copied the text: " + nudgeInfo.text);

  copyToClipboard.textContent = window.nudgeStrings.copied

  event.preventDefault();
})